export default "__VITE_ASSET__D08jslII__"